import { connect } from 'react-redux';

import GetStartedFormModal from './GetStartedFormModal';

export default connect(
    state => ({
        isGetStartedFormVisible: state.getStartedForm.isGetStartedFormVisible
    })
)(GetStartedFormModal);
